module.exports = __webpack_public_path__ + "static/media/marshall-homepage-macbook-iphone-new-small-reduced.9d687e7d.webp";